var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-field-date" },
    [
      _c(
        "CompassFormItem",
        _vm._b({}, "CompassFormItem", _vm.formItemProps, false),
        [
          _c("CompassInput", {
            attrs: {
              value: _vm.localValue,
              type: "number",
              min: 0,
              menuClass: "automation-wizard-field-date"
            },
            on: { input: _vm.handleInput },
            scopedSlots: _vm._u([
              {
                key: "suffix",
                fn: function() {
                  return [
                    _c(
                      "span",
                      {
                        staticClass:
                          "automation-wizard-field-date__suffix typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t.__("common.labels.day_s")) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }